import { Button } from 'antd';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PromptSettingType } from '../../../api/model/bundle';
import PowerFooter from '../../../components/power-footer';
import { useCustomNavigate, useParticleAuth } from '../../../context';
import styles from './index.less';

const MasterPasswordModal = () => {
    const { t } = useTranslation();
    const navigate = useCustomNavigate();
    const { loginSuccessRedirectToApp, modalOptions, setAuthCoreModal } = useParticleAuth();
    const { promptSettingConfig } = modalOptions;

    useEffect(() => {
        setAuthCoreModal({
            closable: false,
        });
        return () => {
            setAuthCoreModal({
                closable: true,
            });
        };
    }, []);

    const navigateToSetMasterPassword = () => {
        navigate('/account/master-password', {
            replace: true,
            state: {
                loginSetMasterPassword: true,
            },
        });
    };

    const laterToSet = () => {
        loginSuccessRedirectToApp();
    };

    return (
        <div className="mp-modal-container">
            <style>{styles as unknown as string}</style>

            <div className="particle-title">{t('account.set_master_password')}</div>

            <div className="scroll-content">
                <div className="mp-set-desc">{t('account.set_master_password_tip')}</div>
                <div className="mp-set-img" />
            </div>

            <div className="btns">
                <Button className="mp-set-now mp-antd-bt" onClick={navigateToSetMasterPassword}>
                    {t('account.set_master_password_now')}
                </Button>

                {
                    // 强制设置主密码，隐藏 Later 按钮
                    promptSettingConfig?.promptMasterPasswordSettingWhenLogin !== PromptSettingType.everyAndNotSkip && (
                        <Button className="mp-set-later mp-antd-bt" onClick={laterToSet}>
                            {t('account.later')}
                        </Button>
                    )
                }
            </div>
            <PowerFooter className="footer-box-v2" />
        </div>
    );
};

export default MasterPasswordModal;
